export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const apiV2 = localStorage.getItem('api_v2')
    return apiV2 ? process.env.API_V2_BASE_URL : process.env.API_BASE_URL
  }
  return process.env.API_BASE_URL
}
